import { render, staticRenderFns } from "./QuickLinks.vue?vue&type=template&id=fc7d221a&scoped=true"
import script from "./QuickLinks.vue?vue&type=script&lang=js"
export * from "./QuickLinks.vue?vue&type=script&lang=js"
import style0 from "./QuickLinks.vue?vue&type=style&index=0&id=fc7d221a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc7d221a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc7d221a')) {
      api.createRecord('fc7d221a', component.options)
    } else {
      api.reload('fc7d221a', component.options)
    }
    module.hot.accept("./QuickLinks.vue?vue&type=template&id=fc7d221a&scoped=true", function () {
      api.rerender('fc7d221a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/component/QuickLinks.vue"
export default component.exports